import { Box, Grid, GridItem, Text } from '@chakra-ui/layout'
import React from 'react'

const HomeCountCard = () => {
    return (
        <Box maxW="90vw" mx="auto" transition="0.5s ease-out">
            <Box 
                // my={20}
                p={8}
                // pt={0}
                boxShadow="-5px 16px 49px -14px #ffbbbb"
                rounded="20px"
                background="white"
            >
                {/* <Text
                    textAlign="center"
                    color="#FB1923"
                    textTransform="uppercase"
                    fontWeight={700}
                    fontSize="4xl"
                    letterSpacing="3px"
                >Our Numbers</Text> */}
                <Grid
                    textAlign={{ base: 'center', sm: 'center', md: 'center', lg: 'center', xl: 'center' }}
                    // mt={1}
                    templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                    gap={{ base: '2', sm: '2', md: '4', lg: '6', xl: '6' }}>
                    <GridItem >
                        <Text
                            className='figures'
                            fontWeight={600}
                            fontSize={{ base: '6xl', sm: '6xl', md: '32px', lg: '52px', xl: '72px' }}
                            // color="#FB1923" 
                            color="#F12121"
                            letterSpacing="2px">35</Text>
                        <Text className='facts' fontSize={16} fontWeight={700} color='#565656'>Partner Hospitals</Text>
                    </GridItem>
                    <GridItem >
                        <Text
                            className='figures'
                            fontWeight={600}
                            // color="#FB1923"
                            color="#F12121"
                            letterSpacing="2px"
                            fontSize={{ base: '6xl', sm: '6xl', md: '32px', lg: '52px', xl: '72px' }}>1,00,000+</Text>
                        <Text fontSize={16} fontWeight={700} color='#565656' className='facts' >Calls Responded</Text>
                    </GridItem>
                    <GridItem >
                        <Text
                            fontWeight={600}
                            className='figures'
                            // color="#FB1923"
                            color="#F12121"
                            letterSpacing="2px"
                            fontSize={{ base: '6xl', sm: '6xl', md: '32px', lg: '52px', xl: '72px' }}>900+</Text>
                        <Text fontSize={16} className='facts' fontWeight={700} color='#565656'>Ambulances & Vehicles</Text>
                    </GridItem>
                </Grid>
            </Box>
        </Box>
    )
}

export default HomeCountCard